import { render, staticRenderFns } from "./createAgent.vue?vue&type=template&id=52926b0b&scoped=true"
import script from "./createAgent.vue?vue&type=script&lang=js"
export * from "./createAgent.vue?vue&type=script&lang=js"
import style0 from "./createAgent.vue?vue&type=style&index=0&id=52926b0b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52926b0b",
  null
  
)

export default component.exports